import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { _pick } from "../utils/setting";

const styles = theme => ({
  title: {
    fontWeight: "500",
    marginBottom: theme.spacing[3]
  }
});
class TypoTitle extends React.Component {
  render() {
    const { classes } = this.props;
    const { children = "", className = "", ...props } = this.props;

    let obj = _pick(props, [
      "root",
      "body2",
      "body1",
      "caption",
      "button",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "subtitle1",
      "subtitle2",
      "overline",
      "srOnly",
      "alignLeft",
      "alignCenter",
      "alignRight",
      "alignJustify",
      "noWrap",
      "gutterBottom",
      "paragraph",
      "colorInherit",
      "colorPrimary",
      "colorSecondary",
      "colorTextPrimary",
      "colorTextSecondary",
      "colorError",
      "displayInline",
      "displayBlock"
    ]);
    return (
      <Typography {...obj} className={classes.title} variant="h5">
        {children}
      </Typography>
    );
  }
}

TypoTitle.propTypes = {
  // onChange: PropTypes.func.isRequired,
};

const mapState = state => ({});

const mapDispatch = dispatch => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(TypoTitle)));
